/*
stats about Japanese syllables
generated from one of the japanesePhonotactics tests
*/

export const japaneseSyllableCounts = {
  1: 528,
  2: 8136,
  3: 30876,
  4: 56151,
  5: 39886,
  6: 32969,
  7: 21397,
  8: 13734,
  9: 6475,
  10: 4040,
  11: 2312,
  12: 1500,
  13: 874,
  14: 595,
  15: 362,
  16: 179,
  17: 126,
  18: 90,
  19: 75,
  20: 38,
  21: 26,
  22: 19,
  23: 21,
  24: 6,
  25: 8,
  26: 4,
  27: 1,
  28: 2,
  29: 1,
  30: 1,
  31: 1,
  35: 1, // 馬を水辺に導く事は出来るが馬に水を飲ませる事は出来ない ɯmaomizɯbenimitɕibikɯkotohadekiɾɯgaɯmanimizɯonomaseɾɯkotohadekinai
  36: 1  // 特定独立行政法人等の労働関係に関する法律 tokɯteidokɯɾitsɯgjoɯseihoɯdʑiɴtoɯnoɾoɯdoɯkaɴkeinikaɴsɯɾɯhoɯɾitsɯ
}

export const japaneseOnsets = {
  '': 330989, k: 154145, ɾ: 103114, s: 72002, t: 63445, m: 58805, ɕ: 51151, g: 45522, n: 43958, b: 38502, d: 32426, dʑ: 24891,
  h: 23048, ts: 21106, tɕ: 19001, z: 18241, p: 15220, ɸ: 13847, ɰᵝ: 8699, ç: 8675, kː: 7441, tː: 5222, pː: 3114, ɕː: 2138,
  sː: 1430, tɕː: 1032, dː: 695, v: 370, gː: 352, tsː: 202, dʑː: 187, ɸː: 47, zː: 31, hː: 29, bː: 25, çː: 4
}

export const japaneseNuclei = {
  ɯ: 267037, i: 230378, a: 213924, o: 173999, e: 115008, ɴ: 94227, jo: 18948, aː: 12094, ja: 8777, jɯ: 8121,
  oː: 8016, iː: 7255, eː: 6824, ɯː: 2653, jɯː: 1522, jaː: 192, joː: 131
}

export const japaneseCodas = {
  '': 1169106
}

export const japaneseFirstOnsets = {
  '': 39426, k: 37035, s: 18722, t: 13642, ɕ: 13484, m: 13209, h: 10756, n: 9382, b: 8399, ɾ: 8268, g: 7969, d: 7231, dʑ: 6325,
  ɸ: 5835, ç: 4715, tɕ: 4547, p: 4148, ts: 2708, z: 2558, ɰᵝ: 1914, v: 129, tː: 12, kː: 8, tsː: 4, tɕː: 3, pː: 3, ɕː: 1, sː: 1, hː: 1
}

export const japaneseOtherOnsets = {
  '': 291563, k: 117110, ɾ: 94846, s: 53280, t: 49803, m: 45596, ɕ: 37667, g: 37553, n: 34576, b: 30103, d: 25195, dʑ: 18566,
  ts: 18398, z: 15683, tɕ: 14454, h: 12292, p: 11072, ɸ: 8012, kː: 7433, ɰᵝ: 6785, tː: 5210, ç: 3960, pː: 3111, ɕː: 2137,
  sː: 1429, tɕː: 1029, dː: 695, gː: 352, v: 241, tsː: 198, dʑː: 187, ɸː: 47, zː: 31, hː: 28, bː: 25, çː: 4
}

export const japaneseLastCodas = {
  '': 220435
}

export const japaneseOtherCodas = {
  '': 948671
}
